// extracted by mini-css-extract-plugin
export var numpadContainer = "_q5-1";
export var phoneButton = "_q5-0";